<script setup>
import UserLoginLogsTable from "@frontJs/components/tables/UserLoginLogsTable.vue";
import DefaultLayout from "@frontJs/layouts/DefaultLayout.vue";
import { Head } from "@inertiajs/vue3";
import PageTitle from "@js/components/titles/PageTitle.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

defineOptions({ layout: DefaultLayout });
</script>

<template>
  <Head>
    <title>{{ t("all.title.logs") }} - {{ t("title.datakepler") }}</title>
  </Head>

  <PageTitle>
    {{ t("all.title.logs") }}
  </PageTitle>

  <UserLoginLogsTable />
</template>
